var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Featured Products")]),_c('p',[_vm._v("Bringing you only the best features for better workload management and smarter business decisions.")]),_c('Product',{attrs:{"info":_vm.arrays.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }